import { BaseQuery } from './BaseQuery';
import { IExecutionOptions } from '../models/query';
import { Query } from './Query';
import { getQueryStringValue } from '../utils/url';
import { IQueryOptionsUrl, TQueryOptionsUrlCode } from '../models/query/options';

interface IOrchestratedPathname {
	isValid: boolean;
	pathname: string;
	pieceCount?: number;
	pieces?: string[];
}

export class UrlQuery extends BaseQuery<IQueryOptionsUrl> {
	initialize(executionOptions: IExecutionOptions) {
		this.fillKeyFromQuery('code', 'codeQuery', executionOptions);
		this.fillKeyFromQuery('key', 'keyQuery', executionOptions);
	}
	getOptions(): IQueryOptionsUrl {
		const { code, codeQuery, key, keyQuery, urlPattern, options = {} } = this.queryOptions;
		return {
			key,
			keyQuery,
			urlPattern,
			codeQuery,
			code: code as TQueryOptionsUrlCode,
			...(options.url || {}),
		};
	}
	getRawValue<T = any>(executionOptions: IExecutionOptions, callStackLevel: number = 1): T {
		const { code, key, urlPattern: urlPatternQueryOptions } = this.options;
		if (code) {
			if (key && code === 'param' && urlPatternQueryOptions && typeof urlPatternQueryOptions === 'object') {
				const urlPatternQuery = new Query(urlPatternQueryOptions, this.translationHelper, callStackLevel + 1);
				const urlPattern = urlPatternQuery.execute(executionOptions);
				const urlPatternOptions = this.orchestrateUrl(urlPattern);

				if (urlPatternOptions && urlPatternOptions.isValid) {
					const currentUrlOptions = this.orchestratePathname(window.location.pathname);
					if (
						currentUrlOptions.isValid &&
						urlPatternOptions.pieceCount === currentUrlOptions.pieceCount &&
						urlPatternOptions.pieces &&
						currentUrlOptions.pieces
					) {
						const index = urlPatternOptions.pieces.indexOf(`:${key}`);
						if (index > -1) {
							return currentUrlOptions.pieces[index] as any as T;
						}
					}
				}
			}
			if (key && code === 'queryString') {
				return getQueryStringValue({ key }, window.location.search) as any as T;
			}
			if (window.location.hasOwnProperty(code)) {
				const windowResponse = window.location[code];
				if (typeof windowResponse !== 'function') {
					return window.location[code] as any as T;
				}
			}
		}
		return;
	}
	orchestratePathname(pathname: string): IOrchestratedPathname {
		let pieces: string[] | undefined;
		let isValid: boolean = true;
		if (!pathname || pathname.length === 0) {
			isValid = false;
		}
		if (isValid) {
			pieces = pathname.substr(1).split('/');
		}
		// Remove the last parameter if it is empty
		if (pieces && pieces.length > 0 && (pieces[pieces.length - 1] === undefined || pieces[pieces.length - 1] === null || pieces[pieces.length - 1].length === 0)) {
			pieces.pop();
		}
		return {
			pieces,
			isValid,
			pathname,
			pieceCount: pieces ? pieces.length : 0,
		};
	}
	orchestrateUrl(url: string): IOrchestratedPathname {
		let pathname = '';
		let isValid: boolean = true;
		let workingUrl = url;
		const hasHostname = workingUrl.startsWith('http://') || workingUrl.startsWith('https://');
		if (!hasHostname) {
			const separator = url.startsWith('/') ? '' : '/';
			workingUrl = `https://www.fakeurl.com${separator}${url}`;
		}
		try {
			const url = new URL(workingUrl);
			pathname = url.pathname;
		}
		catch (e) {
			isValid = false;
		}
		if (!isValid) {
			return {
				isValid,
				pathname,
			};
		}
		return this.orchestratePathname(pathname);
	}
}